import { Component, OnInit, AfterViewInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { Subscription } from 'rxjs';
import { LayoutService } from '../../services/layout.service';
import { NavService } from '../../services/nav.service';
import { UserService } from '../../services/user.service';
import { IUser } from 'src/app/interfaces/iuser';
import { InterceptorMembershipService } from '../../services/interceptor-membership.service';
import { TokenInterceptorService } from '../../services/token.interceptor.service';
import { LanguageService } from '../../services/language.service';
import { EmployeesService } from 'src/app/services/http/employees.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {

  public user: IUser = {}

  public isCollapsed = true;


  public isSidebar = false;
  public config: any = {};
  public isDevMode: boolean = true
  layoutSubscription: Subscription;
  toggleClass = "fe fe-maximize";

  constructor(
    private layoutService: LayoutService,
    public navServices: NavService,
    public userService: UserService,
    public interceptor: TokenInterceptorService,
    public languageService: LanguageService,
    private employeesService: EmployeesService
  ) {
    this.layoutSubscription = layoutService.changeEmitted.subscribe(
      direction => {
        const dir = direction.direction;
      }
    )
  }

  async ngOnInit(){
    this.user = this.userService.user;
  }
  
  categories = [
    { id: 1, name: 'IT Projects' },
    { id: 2, name: 'Business Case' },
    { id: 3, name: 'Microsoft Project' },
    { id: 4, name: 'Risk Management' },
    { id: 5, name: 'Team Building' }
  ]

  toggleSidebarNotification() {
    this.layoutService.emitSidebarNotifyChange(true);
  }

  toggleSidebar() {
    if ((this.navServices.collapseSidebar = !this.navServices.collapseSidebar)) {
      document.querySelector('.main-body').classList.add('main-sidebar-hide');
    }
    else {
      document.querySelector('.main-body').classList.remove('main-sidebar-hide');
    }
  }

  toggleMobileSidebar() {
    if ((this.navServices.collapseSidebar = !this.navServices.collapseSidebar)) {
      document.querySelector('.main-body').classList.add('main-sidebar-show');
    }
    else {
      document.querySelector('.main-body').classList.remove('main-sidebar-show');
    }
  }

  ngAfterViewInit() {
    const sidebar = document.querySelector('.side-menu');
    let ps = new PerfectScrollbar(sidebar);
  }

  signOutHandler() {
    this.userService.signOutCurrentUser();
  }

  public async changeLanguage(language){
    await this.languageService.setSettingsLanguage(language,true);
  }

  public onRoleChange(event: any) {
    const roleId = event._id || event;
    if (roleId) {
      if (this.user.employeeId) {
        this.employeesService.updateDefaultRole(roleId).then(() => {
          window.location.reload();
        }).catch(err => {
          console.error('Error updating default role:', err);
          window.location.reload();
        });
      } else {
        window.location.reload();
      }
    }
  }
}

